module.exports = [
  {
    path: '/consultate',
    component: true,
    redirect: '/consultate/list',
    name: '诊断结果管理',
    children: [
      {
        path: 'list',
        name: '列表',
        component: () => import('@/views/consultate/list'),
      },
    ]
  },
]


// WEBPACK FOOTER //
// ./src/router/consultate.js